module.exports = __webpack_public_path__ + "img/fond-sante-enfant.50fd795a.png";